import NotificationPage from 'modules/notification/desktop/Notification';

export default NotificationPage;
